export const API_PATH_ApiAppPresetDelete = '/services/app/presets/apiAppPresetDelete';
